import type { FC, ReactNode } from 'react'

import Link from 'next/link'

export const Footer: FC = (): ReactNode => {
    const year = new Date().toLocaleDateString('fa-IR', { year: 'numeric' })

    return (
        <div className='footer'>
            <div className='container'>
                <div className='footer-wrapper'>
                    <div className='footer-brand-holder'>
                        <Link href='/' className='footer-brand w-inline-block'>
                            <img src='/images/Logo-Black.svg' alt='OpenBuilds.ir' className='footer-image' />
                        </Link>
                        <p className='grey-text' suppressHydrationWarning>© {year} OpenBuilds.ir، فروشگاه قطعات و کیت دستگاه CNC. ارسال از تهران.</p>
                    </div>

                    <div className='footer-content'>
                        <div className='footer-block'>
                            <div className='title-small'>فروشگاه</div>
                            <Link href='/features' className='footer-link'>دستگاه‌های CNC</Link>
                            <Link href='/pricing' className='footer-link'>پروفیل شیاردار مهندسی</Link>
                            <Link href='/blog' className='footer-link'>آموزش‌ها</Link>
                            <Link href='/about' className='footer-link'>درباره ما</Link>
                            <Link href='/contact' className='footer-link'>تماس با ما</Link>
                        </div>

                        <div className='footer-block'>
                            <div className='title-small'>تماس و واتس‌اپ</div>
                            <a href='tel:09981414040' className='footer-link'>۰۹۹۸۱۴۱۴۰۴۰</a>
                            <a href='tel:09981434040' className='footer-link'>۰۹۹۸۱۴۳۴۰۴۰</a>
                            <a href='https://wa.me/989981414040' target='_blank' rel='noreferrer' className='footer-link'>پیام در واتس‌اپ</a>
                            <Link href='/contact' className='footer-link'>فرم تماس</Link>
                        </div>

                        <div className='footer-block'>
                            <div className='title-small'>پشتیبانی</div>
                            <Link href='/contact#faq' className='footer-link'>ضمانت و خدمات پس از فروش</Link>
                            <Link href='/pricing#faq' className='footer-link'>روش‌های ارسال و پرداخت</Link>
                            <Link href='/blog/profile-buying-guide' className='footer-link'>راهنمای خرید پروفیل</Link>
                        </div>
                    </div>
                </div>

                <div className='footer-divider'>
                    <p className='grey-text'>طرح‌ها و تصاویر دستگاه‌ها از OpenBuilds, LLC و تحت مجوز CC BY-SA 4.0 است. ساخته‌شده با ♥ توسط <a href='https://azwedo.com' target='_blank' rel='noreferrer' className='black-link'>Azwedo</a> و <a href='https://modulify.ai' target='_blank' rel='noreferrer' className='black-link'>Modulify.ai</a></p>
                </div>
            </div>
        </div>
    )
}
